<template>
	<div class="divcreateorder">
		<updateweight_xnd ref="xnd" v-show="type=='鑫诺达'" :curpkval="curpkval"></updateweight_xnd>
	</div>
</template>
<script>
import updateweight_xnd from '@/components/order/updateweight_xnd.vue';
export default {
	components: {
		updateweight_xnd
	},
	props: {
	},
	data() {
		return {
			curpkval:'',
			type:''
		}
	},
	mounted() {
		
	},
	methods:{
		init(param){
			if(param!=undefined){
				if(param.pkval!=undefined){
					this.curpkval=param.pkval;
				}
			}
			var that=this;
			//判断是哪种类型的下单功能,显示对应组件
			this.$apipost.get.CreatePageLayoutType({ sys: '出口系统', fun:'更新重量'}).then(res => {
				if (res != '') {
					if (res.list.length > 0) {
						var list=res.list;
						setTimeout(function(){
							for(var i=0;i<list.length;i++){
								if(list[i].l_type=='默认'){
									if (that.$refs.default != undefined) {
										that.$refs.default.init({pkval:that.curpkval});
										that.type=list[i].l_type;
									}
								}
								if(list[i].l_type=='鑫诺达'){
									if (that.$refs.xnd != undefined) {
										that.$refs.xnd.init({pkval:that.curpkval});
										that.type=list[i].l_type;
									}
								}
							}
						},30);
					}
				}
			});
		}
	}
}
</script>